<template>
  <v-layout column fill-height formlittle>
    <v-flex class="d-flex flex-row page-header mb-3 formlittle flex-grow-0">
      <h1>Les utilisateurs</h1>
      <v-spacer></v-spacer>
      <v-checkbox label="Voir les archives" v-model="showArchive"></v-checkbox>
      <v-btn
        @click="addNewContact"
        depressed
        class="primary2 ml-2"
        v-if="$store.state.myrights.Create_contact"
      >Nouveau</v-btn>
    </v-flex>
    <v-flex class="d-flex flex-grow-1 overflow-hidden">
      <v-layout>
        <v-flex md3 mr-5>
          <v-card class="fill-height" flat>
            <v-card-text class="flex-grow-1 pa-0 overflow-hidden">
              <m-list
                ref="contactslist"
                :dynamic="true"
                :items="contacts"
                item-value="co_id"
                :item-height="30"
                :limit="contacts_limit"
                :skip="contacts_skip"
                :total="contacts_total"
                :current="contact_current"
                @itemclick="contactClick"
                @changerange="changeContactsRange"
              >
                <template v-slot:ths="{ }"></template>
                <template v-slot:tds="{ item }">
                  <td style="width:40px;">
                    <div v-if="item.co_avatar" style="width:25px;height:25px;margin-right:10px;">
                      <v-img
                        :src="item.co_avatar?$config.server_url+'/api/1.0/avatar/'+item.co_id+'/25/25?d='+item.updatedAt:'/img/default-profile.jpg'"
                        height="25px"
                        width="25px"
                        class="rounded-image"
                      ></v-img>
                    </div>
                    <div
                      v-else-if="item.co_type=='contact'"
                      style="width:25px;height:25px;margin-right:10px;"
                    >
                      <v-icon>mdi-account-circle</v-icon>
                    </div>
                    <div v-else style="width:25px;height:25px;margin-right:10px;">
                      <v-icon>mdi-account-circle</v-icon>
                    </div>
                  </td>
                  <td>{{ item | formatContactName }}</td>
                </template>
              </m-list>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md9>
          <v-card class="fill-height overflow-auto" flat>
            <v-card-text>
              <contact-details
                ref="contactdetails"
                v-model="contact_current"
                :clientsuivi="clientsuivi"
                @contactWinEditOpen="contactWinEditOpen"
                @contactWinEditSaved="contactWinEditSaved"
                @contactWinEditCanceled="contactWinEditCanceled"
                @contactWinEditDeleted="contactWinEditDeleted"
              ></contact-details>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from "vue";

export default {
  name: "contacts",
  components: {},
  data() {
    return {
      showArchive: false,
      //////// immo///////////
      searchcontact: "",
      group_current: "all",

      contacts: [],
      contacts_skip: 0,
      contacts_total: 0,
      contacts_limit: 50,
      contacts_current: "",
      contact_current: 0,
      clientsuivi: false,
      contact: null
    };
  },

  watch: {
    async showArchive(val) {
      // console.log("je passe");
      await this.loadContacts(0);
      await this.loadFirstContactOfList();
    },
    async searchcontact(val) {
      await this.loadContacts(0);
      await this.loadFirstContactOfList();
    }
    /* async $route(to, from) {
      if (to.name == "contactsgroup" && to.params.group == "follows") {
        this.group_current = to.params.group;
        await this.loadContacts(0);
        await this.loadFirstContactOfList();
      }
    } */
  },

  async mounted() {
    // if (!this.$route.params.co_id) this.loadFirstContact = true;
    if (this.$route.name == "contactsgroup") {
      this.group_current = this.$route.params.group;
    }
    await this.loadContacts(0);
    await this.loadFirstContactOfList();
    /* if (this.$route.name == "contactsgroup") {
      await this.loadFirstContactOfList();
    }
    if (this.$route.name == "contactslist") {
      await this.loadFirstContactOfList();
    } */
    if (this.$route.name == "contactdetails") {
      this.contact_current = this.$route.params.co_id * 1;
      // await this.loadContact();
    }
    if (this.$route.name == "contactedit") {
      this.contact_current = this.$route.params.co_id * 1;
      // await this.loadContact();
      Vue.nextTick(() => {
        this.$refs.contactdetails.openWinEdit();
      });
    }
  },
  methods: {
    changeContactsRange(skip) {
      this.loadContacts(skip);
    },
    addNewContact() {
      this.contact_current = -1;
      Vue.nextTick(() => {
        this.$refs.contactdetails.openWinEdit();
      });
    },
    setCurrent(co_id) {
      this.contact_current = co_id;
      // this.loadContact();
    },
    async loadFirstContactOfList() {
      if (this.contacts.length) {
        this.contact_current = this.contacts[0].co_id;
        // await this.loadContact();
      }
    },
    async groupClick(evt) {
      let gr_id = evt.target.closest("tr").getAttribute("data-gr-id");
      if (gr_id) {
        this.group_current = gr_id;
        //this.$router.push("/contacts/group/" + this.group_current);
        await this.loadContacts(0);
        await this.loadFirstContactOfList();
      }
    },
    async loadContacts(skip) {
      let params = {
        gr_id: this.group_current,
        skip: skip,
        limit: this.contacts_limit,
        archived: this.showArchive
      };
      // console.log("params", params);
      if (this.searchcontact) params.text = this.searchcontact;
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/contacts",
        { params }
      );
      // console.log("response.data", response.data);
      this.contacts = response.data.data;
      this.contacts_total = response.data.meta.total;
      this.contacts_skip = skip;
      this.$refs.contactslist.update();
      if (skip == 0) this.$refs.contactslist.scrollToTop();
      // if (this.loadFirstContact && this.contacts.length) {
      //   this.contact_current = this.contacts[0].co_id;
      //   this.loadContact();
      // }
    },
    contactClick(row_co, indexCo, evt) {
      // console.log("row_co,indexCo", row_co, indexCo);
      // let co_id = evt.target.closest("tr").getAttribute("data-co-id");
      if (row_co && row_co.co_id) {
        this.$router.push("/contacts/" + row_co.co_id + "/details");
        this.contact_current = row_co.co_id;
        // this.loadContact();
      }
    },

    contactWinEditOpen(co_id) {
      this.$router.push("/contacts/" + co_id + "/edit");
    },
    contactWinEditSaved(co_id) {
      this.contact_current = co_id;
      this.$router.push("/contacts/" + co_id + "/details");
      this.loadContacts(this.contacts_skip);
      // this.loadContact();
    },
    contactWinEditCanceled(co_id) {
      if (!co_id) return this.loadFirstContactOfList();
      this.$router.push("/contacts/" + co_id + "/details");
    },
    async contactWinEditDeleted(co_id) {
      await this.loadContacts(this.contacts_skip);
      await this.loadFirstContactOfList();
      if (this.contacts.length) {
        this.$router.push("/contacts/" + this.contacts[0].co_id + "/details");
      }
    }
  }
};
</script>

<style lang="scss">
// @import "../baseStyle.scss";
@import "../sass/variables.scss";

.table-list {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  tr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    display: block;
    cursor: pointer;
    td {
      padding: 2px 10px;
      font-size: 0.75rem;
      div.txtoverflow {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    &:hover {
      background-color: $gris;
    }
    &.active {
      background-color: $bleu-clair;
      td {
        color: $bleu-fonce;
        i {
          color: $bleu-fonce;
        }
      }
    }
  }
}
</style>
